module.exports = __webpack_public_path__ + "static/media/o_config_up-arrow.12f1ac0f.svg";